import React, { useMemo, useState } from 'react';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Drawer, Space } from 'antd';
import clsx from 'clsx';
import { InputWithLabel } from 'components/Input';
import { useRouter } from 'next/router';
import styles from './Left.module.less';
import { symbols } from '../datas';

import Link from 'next/link';
import { routes } from 'types/routes';

const LeftMobile = () => {
  const [search, setSearch] = useState('');
  const [visible, setVisible] = useState(false);

  const showDrawer = () => {
    setVisible(true);
  };
  const onClose = () => {
    setVisible(false);
  };
  const router = useRouter();
  const { id } = router.query;

  const datas = useMemo(() => {
    let list = Object.keys(symbols);
    if (search) {
      return list.filter((x) => {
        const text = `${x} (${symbols[x].name})`;
        return text.toLowerCase().includes(search.toLowerCase());
      });
    }
    return list;
  }, [search]);

  return (
    <>
      <Button className={styles.btnDrawer} shape="circle" size="large" onClick={showDrawer}>
        <FontAwesomeIcon color="#788686" icon={faSearch} className={styles.searchIcon} size="lg" />
      </Button>
      <Drawer width={360} placement="right" onClose={onClose} visible={visible}>
        <div className={styles.root}>
          <InputWithLabel
            value={search}
            className={styles.searchInput}
            onChange={(e) => setSearch(e.target.value)}
            suffix={<FontAwesomeIcon color="#788686" icon={faSearch} className={styles.searchIcon} size="lg" />}
            searchForm
          />

          <Space className={styles.listCoin} align="end" direction="vertical">
            {datas.map((symbol) => (
              <Link key={symbol} href={`${routes.symbol}/${symbol}`} passHref>
                <Button onClick={onClose} className={clsx({ [styles.active]: id === symbol })} size="large" type="text">
                  {symbol} ({symbols[symbol].name})
                </Button>
              </Link>
            ))}
          </Space>
        </div>
      </Drawer>
    </>
  );
};

export default LeftMobile;
